export enum ResourceType {
    Equipment = 1,
    Room = 2
  }

  export enum ResourceTypesTitle {
    Equipment = 'Equipment',
    Room = 'Room'
  }